import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    AfterViewInit
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';

import {Constants} from '../../../shared/config/constants.config';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {MasterService} from '../../../shared/services/master.service';
import {MacrosComponent} from '../macros/macros.component';
import {DailyMacroChangeFormModalComponent} from '../daily-macro-change-form/daily-macro-change-form.component';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalEventsEmitter} from '../../../shared/events/bsModal.events';
import {DailyMacrosViewModel, MealOverwriteViewModel} from '../../../shared/viewModels/dailyMeal.viewModel';

@Component({
    selector: 'app-daily-macro-change-modal',
    templateUrl: './daily-macro-change.component.html',
    styleUrls: ['./daily-macro-change.component.scss'],
})
export class DailyMacroChangeComponent implements AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    macrosComponent: MacrosComponent;

    bsModalReff: BsModalRef;

    day = '';
    dailyMeal = '';
    masterUserId: number;
    mealOverwrites: MealOverwriteViewModel[] = [];

    dailyOverwrite: DailyMacrosViewModel;
    dailyOverwriteIndex = 0;

    constructor(
        public readonly bsModalRef: BsModalRef,
        public readonly constants: Constants,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly masterService: MasterService,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly bsModalService: BsModalService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
    ) {
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnInit() {

    }

    onClose() {
        this.bsModalRef.hide();
    }

    onCreate() {

    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    openFormModal() {
        this.bsModalReff = this.bsModalService.show(DailyMacroChangeFormModalComponent, {
            backdrop: true
        });

        this.bsModalReff.content.dailyMacroChangeComponent = this;
        this.bsModalReff.content.day = this.day;
        this.bsModalReff.content.dailyMeal = this.dailyMeal;
        this.bsModalReff.content.masterUserId = this.masterUserId;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalReff);
    }

    delete(mealOverwrite: MealOverwriteViewModel) {
        if (confirm('Сигурни ли сте, че искате да изтриете този запис?')) {
            this.macrosComponent.daileMealPercentageOverwrites[this.dailyOverwrite['id']] = this.macrosComponent.daileMealPercentageOverwrites[this.dailyOverwrite['id']].filter(x => x.id !== mealOverwrite.id);
            this.mealOverwrites = this.mealOverwrites.filter(x => x.id !== mealOverwrite.id);
        }
    }
}
